import type { Transition } from 'framer-motion';

/**
 * Motion tokens.
 *
 * One curve for every transition in the portal. `docs/ui-guidelines.md` section 7
 * allows component-scoped micro-interactions only, so these are deliberately short
 * and few: a single entrance curve rather than a bespoke easing per component.
 *
 * `NonNullable<Transition['ease']>` is used because the transition props are optional
 * under `exactOptionalPropertyTypes`: a value typed `... | undefined` cannot be
 * assigned to an optional property. The curve is a four-value CSS `cubic-bezier`,
 * which is what Framer Motion's `BezierDefinition` requires — a three-value tuple
 * such as `[0.2, 0, 1]` is not assignable and will not compile.
 */
export const MOTION_EASE: NonNullable<Transition['ease']> = [0.2, 0, 0, 1];

/** 200 ms. Long enough to read as motion, short enough not to delay content. */
export const MOTION_DURATION = 0.2;
